import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-catalogos",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./catalogos.component.html"
})
export class CatalogosComponent {}
